import { render, staticRenderFns } from "./app-message-popover.vue?vue&type=template&id=283e9cea&scoped=true&"
import script from "./app-message-popover.vue?vue&type=script&lang=js&"
export * from "./app-message-popover.vue?vue&type=script&lang=js&"
import style0 from "./app-message-popover.vue?vue&type=style&index=0&id=283e9cea&lang=less&scoped=true&"
import style1 from "./app-message-popover.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283e9cea",
  null
  
)

export default component.exports